var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExercise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.972,
    height: 39.444,
    viewBox: "0 0 27.972 39.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#9dc6fb;}.b{fill:#80b4fb;}.c{fill:#ecbe6b;}.d{fill:#eab14d;}.e{fill:#e7a52e;}.f{fill:#f9f6f9;}.g{fill:#e7ecf6;}.h{fill:#d8e2f1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.393 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.147,33.087,80.459,28.793a1.156,1.156,0,0,1-.867-1.385L85.683.9A1.156,1.156,0,0,1,87.068.029l18.688,4.294a1.156,1.156,0,0,1,.867,1.385L100.532,32.22A1.155,1.155,0,0,1,99.147,33.087Z",
    transform: "translate(-79.562 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.393 4.093)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.757,53.361l-1-.231L98.9,78.6a1.188,1.188,0,0,1-1.424.892L79.823,75.441l-.231,1a1.155,1.155,0,0,0,.867,1.385l18.688,4.294a1.155,1.155,0,0,0,1.385-.867l6.092-26.512a1.155,1.155,0,0,0-.867-1.385Z",
    transform: "translate(-79.563 -53.13)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 5.771)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M94.781,104.428H75.607a1.156,1.156,0,0,1-1.156-1.156v-27.2a1.156,1.156,0,0,1,1.156-1.156H94.782a1.156,1.156,0,0,1,1.156,1.156v27.2A1.156,1.156,0,0,1,94.781,104.428Z",
    transform: "translate(-74.451 -74.915)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 5.771)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M94.782,74.915H93.751v26.139a1.188,1.188,0,0,1-1.188,1.188H74.451v1.031a1.155,1.155,0,0,0,1.155,1.155H94.782a1.155,1.155,0,0,0,1.155-1.155V76.07a1.155,1.155,0,0,0-1.155-1.155Z",
    transform: "translate(-74.451 -74.915)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.321 11.33)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M110.427,148.263h-5.24a.594.594,0,0,1,0-1.188h5.24a.594.594,0,1,1,0,1.188Z",
    transform: "translate(-104.593 -147.075)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.271)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M110.427,190.722h-5.24a.594.594,0,0,1,0-1.188h5.24a.594.594,0,1,1,0,1.188Z",
    transform: "translate(-104.593 -189.534)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.542)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M110.427,233.183h-5.24a.594.594,0,0,1,0-1.188h5.24a.594.594,0,1,1,0,1.188Z",
    transform: "translate(-104.593 -231.995)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.813)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M110.427,275.644h-5.24a.594.594,0,0,1,0-1.188h5.24a.594.594,0,1,1,0,1.188Z",
    transform: "translate(-104.593 -274.456)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.084)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M110.427,318.1h-5.24a.594.594,0,0,1,0-1.188h5.24a.594.594,0,1,1,0,1.188Z",
    transform: "translate(-104.593 -316.915)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.355)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M110.427,360.564h-5.24a.594.594,0,0,1,0-1.188h5.24a.594.594,0,0,1,0,1.188Z",
    transform: "translate(-104.593 -359.376)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.486 9.93)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M172.329,128.9H159.836a1.188,1.188,0,0,0-1.188,1.188v27.137a1.188,1.188,0,0,0,1.188,1.188h19.109a1.188,1.188,0,0,0,1.188-1.188v-20.52a1.585,1.585,0,0,0-.464-1.12l-6.221-6.221A1.585,1.585,0,0,0,172.329,128.9Z",
    transform: "translate(-158.648 -128.9)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.551)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M179.67,190.113l-2.134-2.134A1.584,1.584,0,0,1,178,189.1v20.52a1.188,1.188,0,0,1-1.188,1.188H158.648v.945a1.188,1.188,0,0,0,1.188,1.188h19.109a1.188,1.188,0,0,0,1.188-1.188v-20.52A1.584,1.584,0,0,0,179.67,190.113Z",
    transform: "translate(-158.648 -187.979)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.008 0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M347.492,136l-6.221-6.221a1.584,1.584,0,0,0-.793-.429V136a.792.792,0,0,0,.792.792h6.651A1.584,1.584,0,0,0,347.492,136Z",
    transform: "translate(-340.478 -129.354)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.008 5.303)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M347.492,199.122l-1.382-1.382h-5.632v1.383a.792.792,0,0,0,.792.792h6.651A1.584,1.584,0,0,0,347.492,199.122Z",
    transform: "translate(-340.478 -197.74)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M201.025,267.682a.594.594,0,1,0,0-1.188H189.264v-2.083h11.761a.594.594,0,0,0,0-1.188H189.264v-.791a.594.594,0,1,0-1.188,0v.791h-1.73a.594.594,0,0,0,0,1.188h1.73v2.083h-1.73a.594.594,0,1,0,0,1.188h1.73v2.083h-1.73a.594.594,0,0,0,0,1.188h1.73v2.083h-1.73a.594.594,0,0,0,0,1.188h1.73v.79a.594.594,0,1,0,1.188,0v-.79h11.761a.594.594,0,0,0,0-1.188H189.264v-2.083h11.761a.594.594,0,0,0,0-1.188H189.264v-2.083Z",
    transform: "translate(-177.178 -241.667)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/exercise.5384c81b96286e13b45c96d90ec5e332.svg";
export { ForwardRef as ReactComponent };